export const statusList = [
  {
    label: "Reason1",
    value: "Reason1",
  },
  {
    label: "Reason2",
    value: "Reason2",
  },
  {
    label: "Reason3",
    value: "Reason3",
  },
  {
    label: "Reason4",
    value: "Reason4",
  },
];
export const cmsContentHeaders = [
  {
    label: "S.No",
  },
  {
    label: "Screen Title",
  },
  {
    label: "Last Modified Date",
  },
  {
    label: "Link",
  },
  // {
  //   label: "URI Link",
  // },
  {
    label: "URI Link",
  },
  {
    label: "Banner Image Preview",
  },
  {
    label: "",
  },
];

export const contentManagementTableHeaders = [
  {
    label: "S.No",
  },
  {
    label: "Screen Title",
  },
  {
    label: "Version",
  },
  {
    label: "Last Modified Date",
  },
  {
    label: "",
  },
];

export const orderDetailHeaderData = [
  {
    label: "Screen Title",
  },
  {
    label: "Last Modified ",
  },
];

export const orderConfirmationAtValues = [
  { id: 1, value: "amount" },
  { id: 2, value: "passbookNo" },
  { id: 3, value: "weight" },
  { id: 4, value: "transactionReferenceNumber" },
  { id: 5, value: "schemeName" },
  { id: 6, value: "paidInstallmentNos" },
  { id: 7, value: "userName" },
];

export const customerManagementTableHeader = [
  {
    label: "S.No",
  },
  {
    label: "Customer ID",
  },
  {
    label: "Name",
  },
  {
    label: "Mobile No",
  },
  {
    label: "E-Mail ID",
  },
  {
    label: "Registered Date",
  },
  {
    label: "No. of Scheme(Active)",
  },
  {
    label: "Weight (gm)",
  },
  {
    label: "Amount Saved (Rs)",
  },
  {
    label: "Last paid date",
  },
  {
    label: "KYC",
  },
  {
    label: "Bank",
  },
  {
    label: "Nominee",
  },
];

export const securityTableHeader = [
  {
    label: "S.No",
  },
  // {
  //   label: "Session ID",
  // },
  {
    label: "Date & Time",
  },
  {
    label: "old Value",
  },
  {
    label: "New Value",
  },
  {
    label: "Source type",
  },
  {
    label: "Field",
  },
  {
    label: "Updated By",
  },

  {
    label: "Activity",
  },
  {
    label: "Approved By",
  },
];

export const sessionTableHeader = [
  {
    label: "S.No",
  },
  // {
  //   label: "Session ID",
  // },
  {
    label: "Start Time",
  },
  {
    label: "End Time",
  },
  {
    label: "Duration (hrs)",
  },
  {
    label: "Device ID",
  },
  {
    label: "Exit type",
  },
];

export const transactionTableHeader = [
  {
    label: "S.No",
  },
  {
    label: "Start Time",
  },

  {
    label: "Transaction ID",
  },
   {
    label: "Passbook ID",
  },
  {
    label: "Transaction Type",
  },
  {
    label: "Autopay Attempt",
  },
  {
    label: "Mode",
  },
  {
    label: "Status",
  },
  {
    label: "End Time"
  }
];

export const genderList = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Other", value: "Other" },
];

export const maritalStatusList = [
  { label: "Single", value: "Single" },
  { label: "Married", value: "Married" },
  { label: "Divorced", value: "Divorced" },
  { label: "Widowed", value: "Widowed" },
];

export const religionList = [
  { label: "Hindu", value: "Hindu" },
  { label: "Christian", value: "Christian" },
  { label: "Muslim", value: "Muslim" },
  { label: "Sikh", value: "Sikh" },
  { label: "Jain", value: "Jain" },
  { label: "Parsi", value: "Parsi" },
  { label: "Jew", value: "Jew" },
  { label: "Buddhist", value: "Buddhist" },
  { label: "Other", value: "Other" },
];

export const remarksStatusList = [
  {
    label: "Technical Issue",
    value: "Technical Issue",
  },
  {
    label: "Auto Refund",
    value: "Auto Refund",
  },
  {
    label: "Request Refund",
    value: "Request Refund",
  },
  {
    label: "Chargeback",
    value: "Chargeback",
  },
  {
    label: "Suspicious Transaction",
    value: "Suspicious Transaction",
  },
  {
    label: "Others",
    value: "Others",
  },
];

export const notificationMediumList = ["Push", "SMS", "Whatsapp"];
export const notificationScheduleList = [
  "Daily",
  "Weekly",
  "Monthly",
  "Yearly",
];
export const notificationSentCustomerHeader = [
  {
    label: "S.No",
  },
  {
    label: "Date",
  },
  {
    label: "Channel",
  },
  {
    label: "Template ID",
  },
  {
    label: "Subject",
  },
  {
    label: "Delivery address",
  },
  {
    label: "Read Status",
  },
  {
    label: "Clicks/Actions",
  },
];

export const liveSchemeTableHeader = [
  {
    label: "S.No",
  },
  {
    label: "Scheme ID",
  },
  {
    label: "Passbook Id",
  },
  {
    label: "DOJ",
  },
  {
    label: "DOM",
  },
  {
    label: "Current Balance (₹)",
  },
  {
    label: "Weight Saved (gm)",
  },
  {
    label: "Last Payment date",
  },
  {
    label: "No. of Payments",
  },
];
export const liveSchemeTableHeaderWithAction = [
  {
    label: "S.No",
  },
  {
    label: "Scheme ID",
  },
  {
    label: "Passbook Id",
  },
  {
    label: "DOJ",
  },
  {
    label: "DOM",
  },
  {
    label: "Current Balance (₹)",
  },
  {
    label: "Weight Saved (gm)",
  },
  {
    label: "Last Payment date",
  },
  {
    label: "No. of Payments",
  },
];
export const pastSchemeTableHeader = [
  {
    label: "S.No",
  },
  {
    label: "Scheme ID",
  },
  {
    label: "Passbook Id",
  },
  {
    label: "DOJ",
  },
  {
    label: "DOM",
  },
  {
    label: "Current Balance (₹)",
  },
  {
    label: "Weight Saved (gm)",
  },
  {
    label: "Last Payment date",
  },
  {
    label: "Redemption Date",
  },
  {
    label: "Status",
  },
  {
    label: "No. of Payments",
  },
];

export const cessionalDetailsTableHeader = [
  {
    label: "S.No",
  },
  {
    label: "Scheme ID",
  },
  {
    label: "Passbook Id",
  },
  {
    label: "DOJ",
  },
  {
    label: "DOM",
  },
  {
    label: "Current Balance (₹)",
  },
  {
    label: "Weight Saved (gm)",
  },
  {
    label: "Last Payment date",
  },

  {
    label: "No. of Payments",
  },
];

export const cessionalReportTableHeader = [
  { label: "Joining Date" },
  { label: "Customer Name" },
  { label: "Phone Number" },
  { label: "Passbook Number" },
  { label: "Maturity Date" },
  { label: "Saved Weight" },
  { label: "Saved Amount" },
  { label: "Redemption Status" },
  { label: "Redemption Date" },
];
export const dgpTransactionTableHeader = [
  {
    label: "S.No",
  },

  {
    label: "Transcation date",
  },
  {
    label: "Status",
  },
  {
    label: "Mode",
  },
  {
    label: "Frequency",
  },
  {
    label: "Type",
  },
  {
    label: "Receipt ID",
  },
  {
    label: "Benefits Earned (gm)",
  },
  {
    label: "Saved Weight (g)",
  },
  {
    label: "Amount (₹)",
  },
  {
    label: "Board Rate (₹)",
  },
  {
    label: "Benefit%",
  },
  {
    label: "DiscountedGold Rate",
  },

  {
    label: "Action",
  },
];

export const sgsTransactionTableHeader = [
  {
    label: "S.No",
  },
  {
    label: "Inst details",
  },
  {
    label: "Transcation date",
  },
  {
    label: "Status",
  },
  {
    label: "Type",
  },
  {
    label: "Receipt ID",
  },
  {
    label: "Saved Weight (g)",
  },
  {
    label: "Amount (₹)",
  },
  {
    label: "Board Rate (₹)",
  },

  {
    label: "Action",
  },
];

export const thangamalTransactionTableHeader = [
  {
    label: "S.No",
  },
  {
    label: "Inst details",
  },
  {
    label: "Transcation date",
  },
  {
    label: "Status",
  },
  {
    label: "Receipt ID",
  },
  {
    label: "Saved Weight (g)",
  },
  {
    label: "Amount (₹)",
  },

  {
    label: "Board Rate (₹)",
  },

  {
    label: "Action",
  },
];

export const lastFiveTransactionTableHeader = [
  { label: "Date" },
  {
    label: "Payment Mode",
    value: "Payment Mode",
  },
  {
    label: "Transaction Id",
    value: "Transaction Id",
  },
  {
    label: "Amount",
    value: "Amount",
  },
  {
    label: "Status",
    value: "Status",
  },
  {
    label: "Action",
    value: "Action",
  },
];

export const deletionUserTableHeader = [
  { label: "Name" },
  { label: "Request Date" },
  { label: "Mobile No." },
  { label: "E-Mail ID" },
  { label: "Status" },
  { label: "Action" },
];

export const passbookTransactionTableHeader = [
  {
    label: "S.No",
  },
  {
    label: "Transcation date",
  },
  {
    label: "Status",
  },
  {
    label: "Type",
  },
  {
    label: "Benefits Earned (gm)",
  },
  {
    label: "Amount (₹)",
  },
  {
    label: "Board Rate (₹)",
  },
  {
    label: "Benefit%",
  },
  {
    label: "DiscountedGold Rate",
  },
  {
    label: "Action",
  },
];

export const viewOutBoxTransactionTableHeader = [
  {
    label: "S.No",
  },
  {
    label: "Transcation date",
  },
  {
    label: "Status",
  },
  {
    label: "Type",
  },
  {
    label: "Benefits Earned (gm)",
  },
  {
    label: "Amount (₹)",
  },
  {
    label: "Board Rate (₹)",
  },
  {
    label: "Benefit%",
  },
  {
    label: "DiscountedGold Rate",
  },
  {
    label: "Action",
  },
];

export const goldRateTableHeader = [
  {
    label: "Date & Time",
    icon: true,
    sort: false,
    value: "createdAt",
  },
  {
    label: "22k Gold(1gram)",
    icon: true,
    sort: false,
    value: "goldRateTwentyTwo",
  },
  {
    label: "24k Gold(1gram)",
    icon: true,
    sort: false,
    value: "goldRateTwentyFour",
  },
];
export const silverRateTableHeader = [
  {
    label: "Date & Time",
    icon: true,
    sort: false,
    value: "createdAt",
  },
  {
    label: "Silver(1gram)",
    icon: true,
    sort: false,
    value: "silverRate",
  },
];
export const goldRateMaintenanceTableHeader = [
  {
    label: "S.No",
  },
  {
    label: "GPP Price",
  },
  {
    label: "In App Price",
  },
  {
    label: "Date & Time",
    icon: true,
    sort: false,
  },
];

export const allOrderSchemeTableHeader = [
  {
    label: "S.No",
  },
  {
    label: "Order ID",
  },
  {
    label: "Status",
  },
  {
    label: "Date & Time ",
    icon: true,
    sort: false,
  },
  {
    label: "Item Name",
  },
  {
    label: "Weight",
  },
  {
    label: "Value",
  },
  {
    label: "Invoice Details",
  },
  {
    label: "Shipping details",
  },
  {
    label: "",
  },
];

export const allOrderFilterDropdownOptions = [
  { label: "Pending", value: "pending" },
  { label: "In Transit", value: "in transit" },
  { label: "Delivered", value: "delivered" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Return", value: "return" },
  { label: "Refund", value: "refund" },
];

export const receiptTableHeader = [
  {
    label: "Date",
  },
  {
    label: "Order ID",
  },
  {
    label: "Payment ID",
  },
  {
    label: "Amount",
  },
  {
    label: "Status",
  },
  {
    label: "Passbook ID",
  },
  {
    label: "Mobile No",
  },
  {
    label: "Receipt ",
  },
  {
    label: "Scheme ID ",
  },
  {
    label: "Action ",
  },
];

export const payStatusList = [
  { label: "All", value: "" },
  { label: "Created", value: 1 },
  { label: "Captured", value: 2 },
  { label: "Failed", value: 3 },

  { label: "Chargeback", value: 8 },
  { label: "Refunded", value: 7 },
];

export const receiptStatusList = [
  { label: "All", value: "" },
  { label: "Single", value: "Single" },
  { label: "Multiple", value: "Multiple" },
  { label: "No", value: "No" },
];

export const receiptModelPayStatusList = [
  { label: "Technical Issue", value: "Technical Issue" },
  { label: "Auto Refund", value: "Auto Refund" },
  { label: "Refund Request", value: "Refund Request" },
  { label: "Chargeback", value: "Chargeback" },
  { label: "Suspicious", value: "Suspicious" },
  { label: "Transaction", value: "Transaction" },
  { label: "Others", value: "Others" },
];

export const campaignCategoryTypeList = [
  {
    label: "Default",
    value: "Default",
  },
  {
    label: "Custom Category",
    value: "Custom Category",
  },
];

export const campaignObjectiveList = [
  { label: "Install", value: "Install" },
  { label: "Join", value: "Join" },
  { label: "Target", value: "Target" },
];

export const campaignPayoutTypeList = [
  {
    label: "Fixed Single",
    value: "Fixed Single",
  },
  {
    label: "Fixed Slab",
    value: "Fixed Slab",
  },
  {
    label: "Milestone",
    value: "Milestone",
  },
];

export const campaignPayoutTimeList = [
  { label: "Every Conversion", value: "Every Conversion" },
  { label: "Every Slab", value: "Every Slab" },
  { label: "End Of Campaign", value: "End Of Campaign" },
];

export const campaignRefereeRewardList = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const campaignConversionActionList = [
  { label: "Single", value: "Single" },
  { label: "Cumulative", value: "Cumulative" },
];

export const campaignLimitList = [
  { label: "None", value: "None" },
  {
    label: "Total Number of conversion",
    value: "Total Number Of Conversion",
  },
];

export const campaignMetricList = [
  { label: "Count", value: "Count" },
  { label: "Amount", value: "Amount" },
];
export const exstingSchemeCustomer = [
  { label: "Not Applicable", value: "NOT_APPLICABLE" },
  { label: "Redemption Within", value: "REDEMPTION_WITHIN" },
];

export const campaignCalculationTypeList = [
  { label: "Tiered", value: "Tiered" },
  { label: "Cumulative", value: "Cumulative" },
];

export const passbookDGPTableHeader = [
  {
    label: "Date",
  },
  {
    label: "Txn Type",
  },
  {
    label: "Document ID",
  },
  {
    label: "Pay mode",
  },
  {
    label: "Ref ID",
  },
  {
    label: "Rept amount(₹)",
  },
  {
    label: "Board rate",
  },
  {
    label: "Weight saved",
  },
  {
    label: "Benefit %",
  },
  {
    label: "Benefit weight",
  },
  {
    label: "Benefit amount(₹)",
  },
  {
    label: "Redeem Weight",
  },
  {
    label: "Redemption amount(₹)",
  },
  {
    label: "Receipt Source",
  },
];

export const passbookSGSWeightTableHeader = [
  {
    label: "Date",
  },
  {
    label: "Txn Type",
  },
  {
    label: "Document ID",
  },
  {
    label: "Pay mode",
  },
  {
    label: "Ref ID",
  },
  {
    label: "Installment Number",
  },
  {
    label: "Due Date",
  },
  {
    label: "Timely",
  },
  {
    label: "Rcpt Amount",
  },
  {
    label: "Board Rate",
  },
  {
    label: "Weight Saved",
  },
  {
    label: "Benefit Amount",
  },
  {
    label: "Redeem Weight",
  },
  {
    label: "Redemption Amount",
  },
  {
    label: "Receipt Source",
  },
];
export const passbookSGSAmountTableHeader = [
  {
    label: "Date",
  },
  {
    label: "Txn Type",
  },
  {
    label: "Document ID",
  },
  {
    label: "Pay mode",
  },
  {
    label: "Ref ID",
  },
  {
    label: "Installment Number",
  },
  {
    label: "Due Date",
  },
  {
    label: "Timely",
  },
  {
    label: "Amount",
  },
  {
    label: "Board Rate",
  },
  {
    label: "Weight Saved",
  },
  {
    label: "Benefit Amount",
  },
  {
    label: "Redeem Weight",
  },
  {
    label: "Redemption Amount",
  },
  {
    label: "Receipt Source",
  },
];
export const passbookFPSTableHeader = [
  {
    label: "Txn Type",
  },
  {
    label: "Document ID",
  },
  {
    label: "Reference ID",
  },
  {
    label: "Amount",
  },
  {
    label: "Board Rate",
  },
  {
    label: "Weight Saved",
  },
  {
    label: "Benefit Amount",
  },
  {
    label: "Redeem Rate",
  },
];
export const customerSummaryTransactionTableHeader = [
  {
    label: "Sub Scheme ID",
  },
  {
    label: "Joining Date",
  },
  {
    label: "Passbook No",
  },
  {
    label: "Passbook Status",
  },
  {
    label: "No. of Payment / Installments",
  },
  {
    label: "Amount Paid (₹)",
  },
  {
    label: "Weight Saved",
  },
  {
    label: "Average Rate(₹)",
  },
  {
    label: "Benefit Weight",
  },
  {
    label: "Date of Maturity",
  },
  {
    label: "Redemption Date",
  },
  {
    label: "Redemption Doc ID",
  },
  {
    label: "Store",
  },
  {
    label: "Benefit Amount (₹)",
  },
  {
    label: "Benefit %",
  },
  {
    label: "Renewal Status",
  },
  {
    label: "Passbook Source",
  },
];
export const customerBalanceReportTableHeader = [
  {
    label: "Customer Name",
  },
  {
    label: "Mobile",
  },
  {
    label: "Total Passbooks",
  },
  {
    label: "Matured Passbook(s)",
  },
  {
    label: "Matured Amount(₹)",
  },
  {
    label: "Matured Weight",
  },
  {
    label: "Redeem Count",
  },
  {
    label: "Redeem Amount(₹)",
  },
  {
    label: "Redeem Weight",
  },
  {
    label: "Active Passbook(s)",
  },
  {
    label: "Saved Amount(₹)",
  },
  {
    label: "Saved Weight",
  },
];

export const redemptionReportTableHeader = [
  {
    label: "Sub Scheme ID",
  },
  {
    label: "Joining Date",
  },
  {
    label: "Customer Name",
  },
  {
    label: "Mobile",
  },
  {
    label: "Pin Code",
  },
  {
    label: "Passbook ID",
  },
  {
    label: "No of Payments",
  },
  {
    label: "Amount Paid (₹)",
  },
  {
    label: "Weight  Saved",
  },
  {
    label: "Average Rate (₹)",
  },
  {
    label: "Benefit Weight",
  },
  {
    label: "Date of Maturity",
  },
  {
    label: "Termination",
  },
  {
    label: "Redemption",
  },
  {
    label: "Age @ Closing",
  },
  {
    label: "Store Code",
  },
  {
    label: "Redemption date",
  },
  {
    label: "Benefit Amount(₹)",
  },
  {
    label: "Benefit %",
  },
  {
    label: "Renewal Status",
  },
  {
    label: "Passbook Source",
  },
  {
    label: "Renewal Date Of Joining"
  }
];
export const schemeCollectionReportTableHeader = [
  {
    label: "Date",
  },
  {
    label: "Sub Scheme ID",
  },
  {
    label: "Joining Date",
  },
  {
    label: "Customer Name",
  },
  // {
  //   label: "Sell Team Agent",
  // },
  {
    label: "Mobile",
  },
  {
    label: "Passbook ID",
  },
  {
    label: "Installment Number",
  },
  {
    label: "Receipt ID",
  },
  {
    label: "Mode of Payment",
  },
  {
    label: "Is First",
  },
  {
    label: "Reference ID",
  },
  {
    label: "Rcpt Amount (₹)",
  },
  {
    label: "Board Rate (₹)",
  },
  {
    label: "Weight Saved",
  },
  {
    label: "Benefit %",
  },
  {
    label: "Benefit Weight",
  },
  {
    label: "Due Date of Installment",
  },
  {
    label: "Timely",
  },
  {
    label: "Payment Status",
  },
  {
    label: "Date of Maturity",
  },
  {
    label: "Receipt Source",
  },
];
export const passbookBalanceReportTableHeader = [
  {
    label: "Sub Scheme Id",
  },
  {
    label: "Customer Name",
  },
  {
    label: "Mobile",
  },
  {
    label: "Joining Date",
  },
  {
    label: "Passbook ID",
  },
  {
    label: "Showroom",
  },
  {
    label: "No. of Installments",
  },
  {
    label: "Passbook Balance (₹)",
  },
  {
    label: "Weight Saved",
  },
  {
    label: "Average Rate(₹)",
  },
  {
    label: "Benefit Weight",
  },
  {
    label: "Status",
  },
  {
    label: "Current Benefit Slab % / Current Installment",
  },
  {
    label: "Date of Maturity",
  },
  {
    label: "Last Payment Date",
  },
  {
    label: "Inactive Days",
  },
  {
    label: "Passbook Source",
  },
];
export const passbookDetailReportTableHeader = [
  ...passbookBalanceReportTableHeader.slice(0, passbookBalanceReportTableHeader.length - 1),
  {label: "Type"},
  { label: "Referral Code" },
  {label: "Campaign ID" },
  { label: "Referred Employee Code" },
  { label: "EMP Showroom" },
  { label: "Reward Amount (₹)" },
  { label: "Reward Coupon Code" },
  
  // keep Passbook Source as last column
  passbookBalanceReportTableHeader[passbookBalanceReportTableHeader.length - 1],
];
export const registrationSummaryTableHeader = [
  {
    label: "#",
  },
  {
    label: "Date",
  },
  {
    label: "Passbook Number",
  },
  {
    label: "Receipt ID",
  },
  {
    label: "Amount (₹)",
  },
  {
    label: "Type",
  },
  {
    label: "Installment Number",
  },
  {
    label: "Due Date",
  },
  {
    label: "Variance",
  },
];
export const reportTableHeaderMain = [
  {
    label: "Date",
  },
  {
    label: "Sub Scheme ID",
  },
  {
    label: "Joining Date",
  },
  {
    label: "Customer Name",
  },
  {
    label: "Mobile",
  },
  {
    label: "Passbook ID",
  },
  {
    label: "No of Instalments",
  },
  {
    label: "Receipt ID",
  },
  {
    label: "Is First",
  },
  {
    label: "Reference ID",
  },
  {
    label: "Rcpt Amount",
  },
  {
    label: "Board Rate",
  },
];

export const redemptionSchemeTableHeader = [
  { label: "S.No." },
  {
    label: "Name",
    value: "schemeName",
  },
  {
    label: "Scheme ID",
    value: "schemeId",
  },
  {
    label: "Passbook Id",
    value: "passbookId",
  },
  {
    label: "DOJ",
    value: "dateOfJoining",
  },
  {
    label: "DOM",
    value: "dom",
  },
  {
    label: "Status",
    value: "status",
  },
  {
    label: "",
  },
];

export const redemptionTableHeaderData = [
  { label: "Eligible for redemption" },
  { label: "Eligible for maturity" },
  { label: "Status" },
  { label: "365 days crossed" },
];

export const passbookDetailsTableHeaderData = [
  {
    label: "Scheme ID",
  },
  { label: "Passbook ID" },
  { label: "DOJ" },
  { label: "DOM" },
  { label: "Current Balance" },
  { label: "Weight Saved" },
  { label: "Last Payment date" },
  { label: "No. of Payments" },
  { label: "Overdue" },
];

export const profilePopupHeaders = [
  {
    label: "Field",
    value: "field",
  },
  {
    label: "Old Value",
    value: "oldValue",
  },
  {
    label: "New Value",
    value: "newValue",
  },
];
export const profilePopupChildrenHeaders = [
  {
    label: "Field",
    value: "field",
  },
  {
    label: "Old Name-New Name",
    value: "oldValue",
  },
  {
    label: "Old Gender-New Gender",
    value: "newValue",
  },
  {
    label: "Old childDob-New childDob",
    value: "newValue",
  },
];

export const profilePopupHeadersBulkUpload = [
  {
    label: "Field",
    value: "field",
  },
  {
    label: "New Value",
    value: "newValue",
  },
];
export const dashboardWorkflowHeaders = [
  { label: "S.No." },
  {
    label: "Date & Time",
    icon: true,
    sort: false,
    value: "createdAt",
  },
  {
    label: "Type of Request",
    value: "requestType",
  },
  {
    label: "Maker Name",
    value: "makerName",
  },
  {
    label: "Status",
    value: "status",
  },
  {
    label: "Updated by",
    value: "UpdatedBy",
  },
  {
    label: "",
  },
];
export const VersionHistoryHeaders = [
  { label: "S.No." },
  {
    label: "Date & Time",
    icon: true,
    sort: false,
    value: "createdAt",
  },
  {
    label: "Type of Request",
    value: "requestType",
  },
  {
    label: "Version History",
    value: "versionHistory",
  },
  {
    label: "Maker Name",
    value: "makerName",
  },
  {
    label: "Status",
    value: "status",
  },
  {
    label: "Updated by",
    value: "UpdatedBy",
  },
  {
    label: "",
  },
];
export const ReasonMasterHeaders = [
  { label: "S.No." },
  {
    label: "Sub Category",
    value: "subCategory",
  },
  {
    label: "Reason",
    value: "reason",
  },
  {
    label: "",
    value: "",
  },
];

export const workflowBulkUploadTableHeader = [
  {
    label: "S.No",
  },
  {
    label: "Scheme ID",
  },
  {
    label: "Passbook Id",
  },
  {
    label: "DOJ",
  },
  {
    label: "DOM",
  },
  {
    label: "Current Balance (₹)",
  },
  {
    label: "Weight Saved (gm)",
  },
  {
    label: "Last Payment date",
  },
  {
    label: "No. of Payments",
  },
  {
    label: "",
    checkbox: true,
  },
];

export const statusFlagList = [
  {
    label: "Active",
    value: "active",
  },

  {
    label: "Inactive",
    value: "inActive",
  },
];
export const userManagementTableHeader = [
  {
    label: "Name",
  },
  {
    label: "Employee ID",
  },
  {
    label: "Role",
  },
  {
    label: "Mobile No.",
  },
  {
    label: "E-Mail ID",
  },
  {
    label: "Added on",
  },
  {
    label: "Status",
  },
  {
    label: "",
  },
  {
    label: "",
  },
];
export const rolesTableHeader = [
  { label: "Role Name" },
  { label: "No. of members" },
  { label: "Added on" },
  { label: "Last Modified" },
  { label: "" },
];
export const showroomMaintenanceTableHeader = [
  {
    label: "S.No.",
  },
  {
    label: "Store Code",
  },
  {
    label: "Mobile No",
  },
  {
    label: "Type",
  },
  {
    label: "City",
  },
  {
    label: "Address",
  },
  {
    label: "Pincode",
  },
  {
    label: "Latitude",
  },
  {
    label: "Longitude",
  },
  {
    label: "Branch",
  },
  {
    label: "Actions",
  },
];

export const newSchemeWarnList = [
  { id: 1, label: "Allow", value: "allow" },
  { id: 2, label: "Don't Allow", value: "dontAllow" },
  { id: 3, label: "Warning", value: "warning" },
];

export const systemConfigOptions = [
  {
    id: 1,
    label: "Mandatory",
    value: "mandatory",
  },
  {
    id: 2,
    label: "Conditional",
    value: "conditional",
  },
  {
    id: 3,
    label: "Optional",
    value: "optional",
  },
];

export const customerParameterConditionList = [
  { label: "Payment Count", value: "paymentCount" },
  { label: "Saved Amount", value: "savedAmount" },
];

export const passbookHistoryDetailList = [
  { label: "Yes", value: "true" },
  { label: "No", value: "false" },
];
export const onlineRedemptionEmail = [
  { label: "No", value: "false" },
  { label: "Yes", value: "true" },
];
export const version = [
  { label: "No", value: "false" },
  { label: "Yes", value: "true" },
];

export const benefitSchemeStatusList = [
  {
    id: 1,
    name: "Active",
    color: "#08A308",
  },
  {
    id: 0,
    name: "Setup",
    color: "#086BA3",
  },
  {
    id: 2,
    name: "Paused",
    color: "#FFA412",
  },
  {
    id: 3,
    name: "Closed",
    color: "#EC7F7F",
  },
];

export const subSchemeManagementTableHeader = [
  {
    label: "Scheme ID",
  },
  {
    label: "Scheme Name",

    value: "name",
  },
];

export const schemeManagementTableHeader = [
  {
    label: "Scheme ID",
  },
  {
    label: "Scheme Name",
    icon: true,
    sort: false,
    value: "name",
  },
  {
    label: "Go Live Date",
    icon: true,
    sort: false,
    value: "goLiveDate",
  },
  {
    label: "Status",
    icon: true,
    sort: false,
    value: "status",
  },
  {
    label: "No. of Sub Schemes",
  },
  {
    label: "No. of Subscribers",
  },
  {
    label: "Scheme Collection",
  },
  {
    label: "Scheme Balance",
  },
  {
    label: "",
  },
];
export const messageModalsForSubschemeList = [
  {
    label: "S.No",
  },
  {
    label: "Screen Title",
  },
  {
    label: "Last Modified Date",
  },
  {
    label: "",
  },
];
export const schemeOrderDetailHeaderData = [
  {
    label: "Screen Title",
  },
  {
    label: "Last Modified ",
  },
];
export const subSchemeDetailsStatusList = [
  {
    id: 0,
    name: "Setup",
    color: "#086BA3",
  },
  {
    id: 1,
    name: "Active",
    color: "#08A308",
  },
  {
    id: 2,
    name: "Paused",
    color: "#FFA412",
  },
  {
    id: 3,
    name: "Closed",
    color: "#EC7F7F",
  },
];

export const createSchemeStatusList = [
  {
    id: 1,
    name: "Active",
    color: "#08A308",
  },
  {
    id: 0,
    name: "Setup",
    color: "#086BA3",
  },
  {
    id: 2,
    name: "Paused",
    color: "#FFA412",
  },
  {
    id: 2,
    name: "Closed",
    color: "#EC7F7F",
  },
];

export const optionsForDGPList = [
  {
    label: "Transaction Failed-DGP",
    value: "Transaction Failed-DGP",
  },
  {
    label: "Transaction success-DGP",
    value: "Transaction success-DGP",
  },
  {
    label: "Transaction success for Initial payment-DGP",
    value: "Transaction success for Initial payment-DGP",
  },
  {
    label: "Benefits-DGP",
    value: "Benefits-DGP",
  },
  {
    label: "Redeem Failed-DGP",
    value: "Redeem Failed-DGP",
  },
  {
    label: "Redeem Success-DGP",
    value: "Redeem Success-DGP",
  },
  {
    label: "How to redeem-DGP",
    value: "How to redeem-DGP",
  },
];
export const optionsForFPSList = [
  {
    label: "How to redeem-FPS",
    value: "How to redeem-FPS",
  },
  {
    label: "Transaction Failed-FPS",
    value: "Transaction Failed-FPS",
  },
  {
    label: "Transaction success-FPS",
    value: "Transaction success-FPS",
  },
  {
    label: "Benefits-FPS",
    value: "Benefits-FPS",
  },
  {
    label: "Transaction success for Initial payment-FPS",
    value: "Transaction success for Initial payment-FPS",
  },
];
export const optionsForSGSList = [
  {
    label: "Transaction Failed-SGS",
    value: "Transaction Failed-SGS",
  },
  {
    label: "Transaction success-SGS",
    value: "Transaction success-SGS",
  },
  {
    label: "Transaction success for Initial payment-SGS",
    value: "Transaction success for Initial payment-SGS",
  },
  {
    label: "Benefits-SGS Weight",
    value: "Benefits-SGS Weight",
  },
  {
    label: "How to redeem-SGS",
    value: "How to redeem-SGS",
  },
  {
    label: "Benefits-SGS Amount",
    value: "Benefits-SGS Amount",
  },
];
export const optionsForTMLList = [
  {
    label: "Transaction Failed-TML",
    value: "Transaction Failed-TML",
  },
  {
    label: "Transaction success for Initial payment-TML",
    value: "Transaction success for Initial payment-TML",
  },
  {
    label: "How to redeem-TML",
    value: "How to redeem-TML",
  },
  {
    label: "Benefits-TML Amount",
    value: "Benefits-TML Amount",
  },
  {
    label: "Transaction success-TML",
    value: "Transaction success-TML",
  },
];
export const quillWhiteList = ["0.75em", "1em", "1.5em", "2.5em"];
export const schemeAgeAnalysisList = ["Above 365", "Matured", "Open", "Total"];
export const trendAnalysisList = [
  {
    schemeReportText: "Registration Trends",
  },
  {
    schemeReportText: "Scheme Balance Trends",
  },
  {
    schemeReportText: "DGP Savings Pattern",
  },
  {
    schemeReportText: "SGS Saving Pattern",
  },
];
export const passbookBalanceReportFilterStatusList = [
  // { name: "All", value: "all" },
  { name: "Active", value: "active" },
  { name: "Matured", value: "matured" },
  { name: "Inactive", value: "inactive" },
  // { name: "Redeemed", value: "redeemed" },
  { name: "Cancelled(Closed)", value: "cancelled" },
];
export const rewaredValueTrackingList = [
  {
    label: "#",
  },
  {
    label: "Value",
  },
  {
    label: "No. of Rewards Issued",
  },
  {
    label: "Issued Value",
  },
  {
    label: "Claimed",
  },
  {
    label: "Claimed Value",
  },
  {
    label: "Claim Value %",
  },
];

export const rewaredConversionTableHeader = [
  {
    label: "#",
  },
  {
    label: "Date of Issue",
  },
  {
    label: "Opening Balance(₹)",
  },
  {
    label: "Value",
  },
  {
    label: "No of Rewards issued",
  },
  {
    label: "Value",
  },
  {
    label: "Rewards claimed",
  },
  {
    label: "Value",
  },
  {
    label: "Conversion %",
  },
  {
    label: "Rewards Expired",
  },
  {
    label: "Value",
  },
  {
    label: "Closing Balance",
  },
  {
    label: "Value",
  },
];

export const sgsSchemeReward = [
  {
    label: "Scheme join date",
  },
  {
    label: "Phone number",
  },
  {
    label: "Passbook number",
  },
  {
    label: "Install amount",
  },
  {
    label: "Option chosen",
  },
  {
    label: "Status",
  },
  {
    label: "Claimed Date",
  },
  {
    label: "Value",
  },
  {
    label: "Issued info",
  },
  {
    label: "Showroom",
  },
];

export const rewaredReportTableHeader = [
  {
    label: "Invoice No",
  },
  {
    label: "Invoice Value",
  },
  {
    label: "Reward ID",
  },
  {
    label: "Coupon No",
  },
  {
    label: "Reward Amount",
  },
  {
    label: "Campaign Name",
  },
  {
    label: "Source",
  },
  {
    label: "Issued Date",
  },
  {
    label: "Expiry Date",
  },
  {
    label: "Status",
  },
  {
    label: "Claimed Date",
  },
  {
    label: "Customer Name",
  },
  {
    label: "Mobile No",
  },
  {
    label: "Passbook No",
  },
  {
    label: "Passbook Type",
  },
];
export const downloadReportsTableHeader = [
  { label: "#" },
  { label: "CreatedAt" },
  { label: "Category" },
  { label: "Sub Category" },
  { label: "Created By" },
  { label: "Applied Filters" },
  { label: "Status" },
  { label: "Actions" },
];
export const summaryBalanceReportTableHeader = [
  {
    label: "Month",
  },
  {
    label: "Opening Balance",
  },
  {
    label: "New Scheme & Collection",
  },
  {
    label: "Redemption",
  },
  {
    label: "Closing Balance",
  },
  {
    label: "Growth",
  },
];
// export const misReportSubSchemeData = [
//   { name: "DGP 1", value: "DGP1" },
//   { name: "SGS 3", value: "SGS3" },
//   { name: "SGS 4", value: "SGS4" },
//   { name: "SGS 5", value: "SGS5" },
//   { name: "SGS 6", value: "SGS6" },
//   { name: "FPS 8", value: "FPS8" },
//   { name: "FPS 11", value: "FPS11" },
// ];

export const valueTrendTableHeader = [
  {
    label: "Month",
  },
  {
    label: "100",
  },
  {
    label: "101-250",
  },
  {
    label: "251-500",
  },
  {
    label: "501-1000",
  },
  {
    label: "1001-5000",
  },
  {
    label: "5001-10000",
  },
  {
    label: "10001-25000",
  },
  {
    label: "25001-50000",
  },
  {
    label: "50001-100000",
  },
  {
    label: "Above 1 Lakh",
  },
  {
    label: "Grand Total",
  },
];

export const savingPatternTrendTableHeader = [
  {
    label: "Join_FY",
  },
  {
    label: "Join_Month",
  },
  {
    label: "Enrollment",
  },
  {
    label: "1-30 days",
  },
  {
    label: "31-60 days",
  },
  {
    label: "61-90 days",
  },
  {
    label: "91-120 days",
  },
  {
    label: "121-150 days",
  },
  {
    label: "151-180 days",
  },
  {
    label: "181-210 days",
  },
  {
    label: "211-240 days",
  },
  {
    label: "241-270 days",
  },
  {
    label: "271-300 days",
  },
  {
    label: "301-330 days",
  },
  {
    label: "Total",
  },
];

export const conversionTrackerTableHeader = [
  {
    label: "Fiscal",
  },
  {
    label: "Month",
  },
  {
    label: "Scheme Balance (Opening)",
  },
  {
    label: "Download",
  },
  {
    label: "Download vs Registration",
  },
  {
    label: "Registration",
  },
  {
    label: "Enrollment",
  },
  {
    label: "Joining",
  },
  {
    label: "Initial Amount",
  },
  {
    label: "Collection",
  },
  {
    label: "Redeem",
  },
  {
    label: "Scheme Balance (Closing)",
  },
];

export const referralCategoryTypeList = [
  {
    label: "Default",
    value: "Default Category",
  },
  {
    label: "Employee Category",
    value: "Employee Category",
  },
  {
    label: "Custom Category",
    value: "Custom Category",
  },
];
export const referralCampaignStatusList = [
  {
    label: "Setup",
    value: "0",
  },
  {
    label: "Live-Open",
    value: "1",
  },
  {
    label: "Pause",
    value: "2",
  },
  {
    label: "Closed",
    value: "3",
  },
  {
    label: "Expiry",
    value: "4",
  },
];

export const referralCategoryStatusList = [
  {
    label: "Setup",
    value: "0",
  },
  {
    label: "Live-Open",
    value: "1",
  },
  {
    label: "Closed",
    value: "2",
  },
  {
    label: "Removed",
    value: "3",
  },
  {
    label: "Pause",
    value: "4"
  }
];

export const referralPaymentOptionsList = [
  {
    label: "DigiGold",
    value: "DigiGold",
  },
  {
    label: "DigiGold and Cash payout",
    value: "DigiGold & cashpayout",
  },
  {
    label: "Cash payout only",
    value: "cashpayout",
  },
];

export const referralShowDashboradList = [
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
];

export const referralShowListOfConversion = [
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
];
export const referrelVendorCode = [
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
];
export const referrelEmployeDetailsFromGpp = [
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
];

export const referralUserCheckboxData = [
  { label: "Name", value: "name", fieldtype: "String" },
  { label: "Employee ID", value: "employeeID", fieldtype: "String" },
  { label: "Branch", value: "branch", fieldtype: "String" },
  { label: "Phone", value: "phone", fieldtype: "Number" },
  { label: "Email", value: "email", fieldtype: "String" },
  { label: "WhatsApp No", value: "whatsappNo", fieldtype: "Number" },
  { label: "Telegram Id", value: "telegramId", fieldtype: "String" },
  { label: "GST No", value: "GSTno", fieldtype: "String" },
  { label: "Address", value: "address", fieldtype: "String" },
  { label: "City", value: "city", fieldtype: "String" },
  { label: "Pincode", value: "pincode", fieldtype: "Number" },
  { label: "PAN No", value: "panNo", fieldtype: "String" },
  { label: "Bio", value: "bio", fieldtype: "String" },
  { label: "Aadhaar", value: "aadhaar", fieldtype: "Number" },
  { label: "Vendor Code", value: "vendorCode", fieldtype: "String" },
  { label: "Gender", value: "gender", fieldtype: "String" },
  { label: "DOB", value: "dob", fieldtype: "String" },
  { label: "Department", value: "department", fieldtype: "String" },
];

export const referralBankCheckboxData = [
  { label: "Bank Name", value: "bankName", fieldtype: "String" },
  { label: "Bank Branch", value: "bankBranch", fieldtype: "String" },
  { label: "Account No", value: "accountNo", fieldtype: "String" },
  { label: "IFSC Code", value: "IFSC", fieldtype: "String" },
];

export const referralSocialCheckboxData = [
  { label: "Facebook", value: "facebook", fieldtype: "String" },
  { label: "Instagram", value: "instagram", fieldtype: "String" },
  { label: "Twitter", value: "twitter", fieldtype: "String" },
  { label: "Youtube", value: "youTube", fieldtype: "String" },
  { label: "ID", value: "ID", fieldtype: "String" },
  {
    label: "No of Monthly Posts",
    value: "noOfMonthlyPosts",
    fieldtype: "String",
  },
  { label: "Followers", value: "followers", fieldtype: "String" },
];
export const referallCategoriesTableHeader = [
  { label: "Category Name" },
  { label: "Category  Type" },
  { label: "No of members" },
  { label: "Created Date" },
  { label: "Category Status" },
  { label: "Action" },
];
export const activeConversionMediaReportTableHeader = [
  {
    label: "Campaign ID",
  },
  {
    label: "Campaign Name",
  },
  {
    label: "Start Date",
  },
  {
    label: "End Date",
  },
  {
    label: "Status",
  },
  {
    label: "",
  },

  {
    label: "SMS",
  },
  {
    label: "WhatsApp",
  },

  {
    label: "Social",
  },
];

export const mediaAnalysisTableHeader = [
  {
    label: "Start Date",
  },
  {
    label: "End Date",
  },
  {
    label: "Campaign ID",
  },
  {
    label: "No.of Shares",
  },
  {
    label: "No. of Conversions",
  },
  {
    label: "Conversion Percentage",
  },
  {
    label: "SMS",
  },
  {
    label: "WhatsApp",
  },
  {
    label: "Email",
  },
  {
    label: "Social",
  },
];
export const activeConversionReportTableHeader = [
  { label: "Conversion ID" },
  { label: "Conversions Date" },
  { label: "Category Name" },
  { label: "Campaign ID" },
  { label: "Campaign Name" },
{
  label: "Sub Scheme ID",
},
  { label: "Referer Name" },
  { label: "Emp Code" },
  { label: "Showroom" },

  { label: "Referer Number" },

  { label: "Referer Reward Value" },
  { label: "Referer Payout Value" },
  { label: "Referer Reward Issue Status" },
  { label: "Referer Payout Issue Status" },
  { label: "Referer Reward Claim  Date" },
  { label: "Referer Payout Claim Date" },

  { label: "Conversion" },
  { label: "Referee Name" },
  { label: "Referee Number" },

  { label: "Referee Reward Value" },
  { label: "Referee Payout Value" },
  { label: "Referee Reward Issue Status" },
  { label: "Referee Payout Issue Status" },

  { label: "Referee Reward Claim Date" },
  { label: "Referee Payout Claim Date" },
  { label: "Passbook Number" },
  { label: "Scheme Amount" },
  { label: "Referral Code" }

];
export const activePayoutReportTableHeader = [
  {
    label: "Payout  ID",
  },
  {
    label: " Date",
  },
  {
    label: "User",
  },
  {
    label: "Category",
  },
  {
    label: "Mobile No",
  },
  {
    label: "No.of Conversions",
  },
  {
    label: "Payout Amount",
  },
  {
    label: "Payment Date",
  },
  {
    label: "Mode",
  },
];
export const activeRewardReportTableHeader = [
  {
    label: "Reward ID",
  },
  {
    label: "Issue Date",
  },
  {
    label: "Expiry Date",
  },
  {
    label: "Campaign ID",
  },
  {
    label: "Campaign Name",
  },
  {
  label: "Sub Scheme ID",
},
  {
    label: "Conversion ID",
  },
  {
    label: "User",
  },
  {
    label: "Type",
  },
  {
    label: "Category",
  },

  {
    label: "Amount",
  },
  {
    label: "Reward Status",
  },
  {
    label: "Claimed Date",
  },
  {
    label: "Employe Code",
  },
  {
    label: "Showroom",
  },
  {
    label: "Passbook No",
  },
  {
    label: "Receipt Number",
  },
];
export const userActivityTrackerReportTableHeader = [
  {
    label: "Campaign Id",
  },
  {
    label: "Campaign Name",
  },
  {
    label: "Status",
  },
  {
    label: "Name",
  },
  {
    label: "Mobile No",
  },
  {
    label: "Objective",
  },

  {
    label: "Created Date",
  },
  {
    label: "End Date",
  },
  {
    label: "Category",
  },
  {
    label: "Emp Code",
  },
  {
    label: "Showroom",
  },
  {
    label: "Vendor Code",
  },
  {
    label: "No. of Shares",
  },
  {
    label: "SMS",
  },
  {
    label: "WhatsApp",
  },
  {
    label: "Social",
  },
  {
    label: "No. of Conversions",
  },
  {
    label: "Reward Issued",
  },
  {
    label: "Reward Issued Amount",
  },
  {
    label: "Reward Claimed",
  },
  {
    label: "Reward Claimed Amount",
  },
  {
    label: "Reward Expired",
  },
  {
    label: "Reward Expired Amount",
  },
  {
    label: "Payout Earned",
  },
  {
    label: "Payout Processed",
  },
  {
    label: "Last Payout Date",
  },
  {
    label: "Current Earnings",
  },
];

export const userSummaryTrackerTableHeader = [
  {
    label: "User",
  },
  {
    label: "Mobile Number",
  },
  {
    label: "Category",
  },
  {
    label: "Emp Code",
  },
  {
    label: "Showroom",
  },
  {
    label: "Vendor Code",
  },
  {
    label: "Campaign ID",
  },
  {
    label: "Campaign Name",
  },
  {
    label: "No. of Shares",
  },
  {
    label: "No. of Conversions",
  },

  {
    label: "Reward Issued",
  },
  {
    label: "Reward Issued Amount",
  },
  {
    label: "Reward Claimed",
  },
  {
    label: "Reward Claimed Amount",
  },
  {
    label: "Reward Expired",
  },
  {
    label: "Reward Expired Amount",
  },

  {
    label: "Payout Earned",
  },

  {
    label: "Payout Processed",
  },
  {
    label: "Last Payout Date",
  },
  {
    label: "Current Earnings",
  },
];
export const applicationProcessingTableHeader = [
  {
    label: "Category Name",
  },
  {
    label: "Requests",
  },
  {
    label: "Approved",
  },
  {
    label: "Pending",
  },
  {
    label: "Rejected",
  },
];
export const faqTableHeader = [
  { label: "S.No" },
  { label: "Title" },
  { label: "Status" },
  { label: "Actions" },
];

export const categoryStatusDataList = [
  {
    label: "Setup",
    value: "Setup",
  },
  {
    label: "Active",
    value: "Active",
  },
  {
    label: "Close Category",
    value: "Close",
  },
  {
    label: "Remove Category",
    value: "Remove",
  },
  {
    label: "Pause Category",
    value: "Pause"
  }
];

export const categoryListDetailsHeader = [
  { label: "Name" },
  { label: "Category " },
  { label: "Mobile No." },
  { label: "E-Mail ID" },
  { label: "Added on" },
  { label: "No of Digi Gold Passbooks" },
];

export const statusFlagNumberList = [
  { label: "Active", value: 1 },
  { label: "InActive", value: 2 },
];
export const campaginSummaryReportTableHeader = [
  {
    label: "Campaign ID",
  },
  {
    label: "Campaign Name",
  },
  {
    label: "Status",
  },
  {
    label: "Objective",
  },
  {
    label: "Created Date",
  },
  {
    label: "End Date",
  },
  {
    label: "Target Category",
  },

  {
    label: "No. of Members (As on Date)",
  },
  {
    label: "No. of User Participated",
  },
  {
    label: "Participation %",
  },
  {
    label: "No. of Shares",
  },
  {
    label: "No. of Conversions",
  },
  {
    label: "Reward Issued",
  },
  {
    label: "Reward Issued Amount",
  },
  {
    label: "Reward Claimed",
  },
  {
    label: "Reward Claimed Amount",
  },
  {
    label: "Reward Expired",
  },
  {
    label: "Reward Expired Amount",
  },
];

export const monthsList = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const applicationInboxTableHeader = [
  { label: "Name" },
  { label: "Request Date" },
  { label: "Category Applied" },
  { label: "Mobile No." },
  { label: "E-Mail ID" },
  { label: "Status" },
  { label: "Action" },
];
export const userTrackingTableHeaders = [
  { label: "Name" },
  { label: "Old Category" },
  { label: "Mobile No" },
  { label: "Email ID" },
  { label: "New Category" },
  { label: "Change Date" },
  { label: "Method" },
  { label: "Status" },
];

export const inboxReasonDropdownList = [
  { label: "Technical Issue", value: "Technical Issue" },
  { label: "Auto Refund", value: "Auto Refund" },
  { label: "Refund Request", value: "Refund Request" },
  { label: "Chargeback", value: "Chargeback" },

  { label: "Suspicious", value: "Suspicious" },

  { label: "Transaction", value: "Transaction" },
  { label: "Others", value: "Others" },
];

export const multiLanguageTableHeader = [
  {
    label: "S.No.",
  },
  {
    label: "Language",
  },
  {
    label: "Language Code",
  },
  {
    label: "Is Active",
  },
  {
    label: "Actions",
  },
];

export const languages = [
  {
    id: 1,
    name: "English",
    nativeName: "English",
    isoCode: "en",
    isChecked: false,
  },
  {
    id: 2,
    name: "Tamil",
    nativeName: "தமிழ்",
    isoCode: "ta",
    isChecked: false,
  },
  {
    id: 3,
    name: "Hindi",
    nativeName: "हिंदी",
    isoCode: "hi",
    isChecked: false,
  },
  {
    id: 4,
    name: "Telugu",
    nativeName: "తెలుగు",
    isoCode: "te",
    isChecked: false,
  },
  {
    id: 5,
    name: "Malayalam",
    nativeName: "മലയാളം",
    isoCode: "ml",
    isChecked: false,
  },
  {
    id: 6,
    name: "Marathi",
    nativeName: "मराठी",
    isoCode: "mr",
    isChecked: false,
  },
  {
    id: 7,
    name: "Urdu",
    nativeName: "اردو",
    isoCode: "ur",
    isChecked: false,
  },
  {
    id: 8,
    name: "Bengali",
    nativeName: "বাংলা",
    isoCode: "bn",
    isChecked: false,
  },
  {
    id: 9,
    name: "Punjabi",
    nativeName: "ਪੰਜਾਬੀ",
    isoCode: "pa",
    isChecked: false,
  },
  {
    id: 10,
    name: "Gujarati",
    nativeName: "ગુજરાતી",
    isoCode: "gu",
    isChecked: false,
  },
  {
    id: 11,
    name: "Odia",
    nativeName: "ଓଡ଼ିଆ",
    isoCode: "or",
    isChecked: false,
  },
  {
    id: 12,
    name: "Kannada",
    nativeName: "ಕನ್ನಡ",
    isoCode: "kn",
    isChecked: false,
  },
];

export const kycReportHeaders = [
  {
    label: "S.No",
  },
  {
    label: "KYC detail",
  },
  {
    label: "Updated date",
  },
  {
    label: "Source type",
  },
  {
    label: "Old value",
  },
  {
    label: "New value",
  },
  {
    label: "Customer name",
  },
  {
    label: "Phone number",
  },
  {
    label: "Passbook no",
  },
  {
    label: "Updated by",
  },
  {
    label: "Approved by",
  },
];

export const SourceTypeoptions = [
  {
    label: "All",
    value: "All",
  },
  {
    label: "Admin",
    value: "Admin",
  },
  {
    label: "Customer",
    value: "Customer",
  },
  {
    label: "GPP",
    value: "GPP",
  },
];

export const offerDetailsCms = {
  bannerBgColor: "#f29c07",
  bannerTextColor: "",
  bannerfooterColor: "",
  borderHighlightColor: "",
  bannerMediaUrl: "",
  bannerMediaMimeType: "",
  bannerMediaKey: "",
  caption: "",
  captionColor: "",
  headline: "",
  headlineColor: "",
  description: "",
  descriptionColor: "",
  detailsPageBgColor: "",
  shareButtonColor: "",
  shareIconColor: "",
  campaignTextThemeColor1: "",
  campaignTextThemeColor2: "",
  campaignTitleColor: "",
  campaignHeadLineColor: "",
  campaignTextColor: "",
  flagColor: "",
  flagTextColor: "",
  pageHeading: "",
  stepsLineColor: "",
  stepsTextColor: "",
  pageDscription: "",
  headlineTextColor: "",
  descriptionTextColor: "",
  shareContentData: [
    { label: "Whatsapp", value: "whatsapp", isActive: false, description: "" },
    {
      label: "Social Media",
      value: "social",
      isActive: false,
      description: "",
    },
    { label: "SMS", value: "SMS", isActive: false, description: "" },
  ],
  offerDescriptionMediaUrl: "",
  offerDescriptionMediaMimeType: "",
  offerDescriptionMediaKey: "",
  IconMediaUrl: "",
  IconMediaKey: "",
  IconMediaMimeType: "",
  sharerewardBackgroundColor: "",
  rewardTextColor: "",
  rewardLabelColor: "",
  shareTextColor: "",
  offerName: "",
  tabBorder: "",
  couponBorder: "",
  cardBorder: "",
  IconColor: "",
  terms: "",
  subSectionData: [
    {
      title: "",
      descriptionColor: "",
      titleColor: "",
      mediaKey: "",
      mediaURL: "",
      mediaMimeType: "",
      description: "",
    },
  ],
};

export const MultiLaunguageMobileStaticData = [
  {
    label: "S.No",
  },
  {
    label: "Content",
  },
  {
    label: "Type",
  },

  {
    label: "Device",
  },
  {
    label: "Screen",
  },
  {
    label: "Component",
  },
  {
    label: "Description",
  },
  {
    label: "Language",
  },
  {
    label: "Action",
  },
];

export const EmployeeManagementHeaders = [
  { label: "Emp Name" },
  { label: "Emp Code" },
  { label: "Mobile Number" },
  { label: "Showroom" },
  { label: "Department" },
  { label: "Gender" },
  { label: "Status" },
  { label: "" },
];
export const campaignList = [
  {
    value: "all",
    label: "All campaigns",
  },
  { value: "live", label: "Live Campaigns" },
];
export const registrationsummaryTable = [
  {
    label: "#",
  },
  {
    label: "Registration Date",
  },
  {
    label: "Customer Name",
  },
  {
    label: "Mobile",
  },
  {
    label: "Address",
  },
  {
    label: "State",
  },
  {
    label: "PINcode",
  },
  {
    label: "Email ID",
  },
  {
    label: "Conversion Status",
  },
];
export const schemecustomersummaryTable = [
  {
    label: "#",
  },
  {
    label: "Joining Date",
  },
  {
    label: "SchemeID",
  },
  {
    label: "Customer Name",
  },
  {
    label: "Mobile",
  },
  {
    label: "Email ID",
  },
  {
    label: "No. of Active passbooks",
  },
  {
    label: "Total passbooks",
  },
];
export const customerHeaders = [
  { label: "#" },
  { label: "Joining Date" },
  { label: "Customer Name" },
  { label: "Mobile" },
  { label: "Email ID" },
  { label: "No. of Active passbooks" },
  { label: "Total passbooks" },
];

export const nonCustomerHeaders = [
  { label: "#" },
  { label: "Joining Date" },
  { label: "schemeID" },
  { label: "Customer Name" },
  { label: "Mobile" },
  { label: "Email ID" },
  { label: "Passbook Number" },
  { label: "1st Payment Amount" },
  { label: "City/Location" },
  { label: "Pincode" },
  { label: "Pan Number" },
  { label: "Nearby showroom" },
];
export const activepassbooksummaryHeaders = [
  {
    label: "#",
  },
  {
    label: "Subs Scheme ID",
  },
  {
    label: "Customer Name",
  },
  {
    label: "Mobile",
  },
  {
    label: "Joining Date",
  },
  {
    label: "Passbook Id ",
  },
  {
    label: "No. of Installments",
  },
  {
    label: "Passbook Balance",
  },
  {
    label: "Weight Saved",
  },
  {
    label: "Average Rate(₹)",
  },
  {
    label: "Benefit Weight",
  },
  {
    label: "Status",
  },
  {
    label: "Current Benefit Slab %",
  },
  {
    label: "Date of Maturity",
  },
  {
    label: "Last Payment Date",
  },
  {
    label: "Inactive Days",
  },
];
export const maturedVsredeemedHeaders = [
  {
    label: "#",
  },

  {
    label: "Customer Name",
  },
  {
    label: "Mobile",
  },

  {
    label: "Date of Maturity",
  },
  {
    label: "No of days After maturity",
  },
  {
    label: "Scheme ID",
  },
  {
    label: "Passbook Number",
  },
  {
    label: "No of Payments",
  },
  {
    label: "Saved Amount(₹)",
  },
  {
    label: "Saved Weight",
  },
  {
    label: "Benefit Weight",
  },
  {
    label: "Average Rate(₹)",
  },
  {
    label: "Last Payment Date",
  },
];
export const sgscollectionsummaryHeaders = [
  {
    label: "#",
  },
  {
    label: "Date",
  },
  {
    label: "Sub Scheme ID",
  },
  {
    label: "Customer Name",
  },
  {
    label: "Mobile",
  },
  {
    label: "Passbook",
  },
  {
    label: "Installment Number",
  },

  {
    label: "Receipt ID",
  },
  {
    label: "Is First",
  },

  {
    label: "Reference ID",
  },

  {
    label: "Rcpt Amount",
  },

  {
    label: "Board Rate(₹)",
  },
  {
    label: "Weight Saved",
  },
  {
    label: "Benefit%",
  },
  {
    label: "Benefit Weight",
  },
  {
    label: "Due Date of Installment",
  },
  {
    label: "Timely",
  },
  {
    label: "Date of Maturity",
  },
  {
    label: "Passbook Source",
  },
];
export const dgpTargetcollectionreportHeaders = [
  { label: "#" },
  { label: "Name" },
  { label: "Phone" },
  { label: "Email" },
  { label: "Register Date" },
  { label: "Passbook" },
  { label: "Date of Joining" },
  { label: "Passbook Age" },
  { label: "Target Set Date" },
  { label: "Target Set (grams)" },
  { label: "Type" },
  { label: "Target Value" },
  { label: "Saved Weight" },
  { label: "Target Till Date" },
  { label: "Target Achieved %" },
  { label: "Weight To Save" },
  { label: "Value To Be Paid" },
  {label:"Passbook Balance"},
  { label: "Target Status" },
];

export const sgscollectionpatternsummary = [
  {
    label: "Passbook Profile",
  },
  {
    label: "Count of Passbook",
  },
  {
    label: "Dues Required",
  },
  {
    label: "Dues Paid",
  },
];

export const posReportHeader = [
  { label: "#", key: "index" },
  { label: "Lead create Date", key: "leadCreateDate" },
  { label: "Time", key: "leadCreateTime" },
  { label: "Customer name", key: "customerName" },
  { label: "Mobile", key: "mobileNumber" },
  { label: "Lat, Long", key: "latLang" },
  {
    label: "Address",
    key: "address",
    isTooltip: true,
  },
  { label: "EMP Name", key: "empName" },
  { label: "EMP ID", key: "empId" },
  { label: "Branch", key: "branch" },
  { label: "Customer status", key: "customerStatus" },
  { label: "Date of visit", key: "DateOfVisit" },
  { label: "No. of visit", key: "noOfVisit" },
  {
    label: "Lead Status",
    key: "leadStatus",
  },
];

export const gppledgerCategory = [
  {
    label: "Employee",
    value: "Employee",
  },
  {
    label: "Customer",
    value: "Customer",
  },
  {
    label: "Supplier",
    value: "Supplier",
  },
];
export const adharPanVerifiedReportsHeaders = [
  {
    label: "Customer name",
  },
  {
    label: " Phone",
  },
  {
    label: "Email",
  },
  {
    label: "Register date",
  },
  {
    label: "Type",
  },
  {
    label: "Updated date",
  },
  {
    label: " Surepass verified date",
  },

];
export const emailVerifiedCustomerReportHeaders = [
  {
    label: "Customer name",
  },
  {
    label: " Phone",
  },
  {
    label: "Email",
  },
  {
    label: "Register date",
  },
  {
    label: "Email update date",
  },
  {
    label: " Email verified date",
  },
  {
    label: "no. of update",
  }
];
export const reviewReport = [
  {
    label: "Register date",
  },
  {
    label: " Customer Name",
  },
  {
    label: "Phone",
  },
  {
    label: "Email",
  },
  {
    label: "First Modal show date",
  },
  {
    label: "Count of modal showed",
  },
  {
    label: "Review submitted date",
  }
];




export const zeroBounceReporHeaders = [
  {
    label: "Email",
  },
  {
    label: "Date and time",
  },
  {
    label: "Status",
  },
  {
    label: "Substatus",
  },
  {
    label: "Activity",
  },

];
export const surePassReportHeaders = [
  {
    label: "Date and time",
  },
  {
    label: "Phone",
  },
  {
    label: "Register date",
  },
  {
    label: "Type",
  },
  {
    label: "Status",
  },




];
export const callbackRequestReportHeaders = [
  {
    label: "S.No",
  },
  {
    label: "Customer Name",
  },
  {
    label: "Mobile",
  },
  {
    label: "Email",
  },
  {
    label: "Scheme Name",
  },
  {
    label: "Callback Requested On",
  },
];
export const customerReportHeaders = [{
  label: "SN",
},
{ label: "Registration Date", },
{ label: "Customer Name", }
  , { label: "Mobile", },
{ label: "Area", },
{ label: "City", },
{ label: "State", },
{ label: "PINcode", },
{ label: "Email ID", },
// { label: "Family details", },
// { label: "Personnel details", },

{ label: "Conversion Status", },
{ label: "Nearest showroom", },
{ label: "Is PAN updated", },
{ label: "Is PAN verified", },
{ label: "Is aadhar updated", },
{ label: "Is Aadhar verified", },
{ label: "Is family details updated", },
{ label: "Is personal details updated", },
{ label: "DOB", },
{ label: "Gender", },
{ label: "Religion", },
{ label: "Last active date", },
]
export const typeOptions = [
  { label: "APP", value: "app" },
  { label: "GPP", value: "gpp" },
];

export const datadeletionreportHeaders = [

  {
    label: "Customer Name",
  },
  {
    label: "Register date",
  },
  {
    label: "Mobile",
  }, {
    label: "Email",
  },
  { label: "Data Deletion Request Date ", },
  {
    label: "Passbook",
  },
  {
    label: "Request Approve Date",
  },
];


export const subikshamReportHeader = [
  { label: "#", key: "index" },

  {
    label: "Created Date",
    key: "createdAt",
    isDate: true,
  },

  {
    label: "Customer Name",
    key: "customerName",
  },

  {
    label: "Mobile Number",
    key: "mobileNumber",
  },
  {
    label: "Alternate Phone Number",
    key: "alternateMobileNumber",
  },
  {
    label: "Customer SMS Code",
    key: "code",
  },
  {
    label: "Desired Purchase Weight (grams)",
    key: "desiredPurchaseWeight"
  }
  ,

  {
    label: "Address",
    key: "address",
    isTooltip: true,
  },

  {
    label: "EMP Name / Customer Name",
    key: "empName",
  },

  {
    label: "EMP Code",
    key: "empCode",
  },
  {
    label: "Remarks",
    key: "remarks",
    isTooltip: true,
  },

  {
    label: "Emp Branch",
    key: "empBranch",
  },

  {
    label: "Send SMS",
    key: "sendSMS",
    isBoolean: true, // optional – for Yes/No or toggle
  },

  {
    label: "File",
    key: "fileUrl",
    isLink: true, // optional – if you want to open/download
  },
];
export const sponcerReport = [
  {
    label: "#",
    key: "index",
  },
  {
    label: "Created Date",
    key: "createdAt",
    isDate: true,
  },
  {
    label: "Customer Name",
    key: "customerName",
  },
  {
    label: "Mobile Number",
    key: "mobileNumber",
  },
  {
    label: "Alternate Phone Number",
    key: "alternateMobileNumber",
  }
  ,
  {
    label: "Address",
    key: "address",
    isTooltip: true,
  },
  {
    label: "Event Name",
    key: "eventName",
  },


  {
    label: "Event Location",
    key: "eventLocation",
  },
  {
    label: "EMP Name / Customer Name",
    key: "empName",
  },

  {
    label: "EMP Code",
    key: "empCode",
  },

  {
    label: "Emp Branch",
    key: "empBranch",
  },
];
export const mandatepageColumns = [
  {
    label: "Date",
    key: "createdAt",
    isDate: true,
  },

  {
    label: "Order ID",
    key: "rzp_order_id",
  },
  {
    label: "Payment ID",
    key: "paymentId",
  },
  {
    label: "Amount",
    key: "amountPaid",
  },
  {
    label: "Status",
    key: "status", // You might want to map 2 => "Success"/"Failed", etc.
  },
  {
    label: "Passbook ID",
    key: "userSchemePassbookId",
  },
  {
    label: "Mobile No",
    key: "mobileNumber",
  },

  {
    label: "Scheme ID",
    key: "subSchemeUniqueId",
  },
  {
    label: "Action",
    key: "action",
    isButton: "true",
  },
];

export const mandateReportTableheaders = [
  { label: "S.No" },
  {
    label: "Customer mobile number",
  },
  { label: "Passbook" },
  { label: "Payment ID" },
  { label: "Installment No" },

  { label: "Amount" },
  {
    label: "Attempt No.",
  },
  {
    label: "Presented date",
  },
  { label: "Payment Status" },
  { label: "Receipt Status" },
  {
    label: "Response date",
  },
  {
    label: "Failure reason",
  },

];
export const mandateReport = [
  { label: "S.No" },
  { label: "Cust mobile no" },
  { label: "Passbook No" },
  { label: "Scheme join date" },
  { label: "Scheme amount" },
  { label: "Autopay set date" },
  { label: "Mandate Type" },
  { label: "Authorizing transaction value" },
  { label: "Auth transaction status" },
  { label: "No. of install set in autopay" },
  { label: "No. of autopay processed" },
  { label: "Status" },
  { label: "Updated date" },
  {
    label: "Payment Id",
  },
  {
    label: "Schedule Token"
  }
];
export const campaignObjectiveOptions = [
  { label: "Verify email", value: "Verify email" },
  { label: "Personal details", value: "Personal details" },
  { label: "Aadhar number", value: "Aadhar number" },
  { label: "Family details", value: "Family details" },
  {label: "Nearest showroom", value:"Nearest showroom"}
];
export const targetCategoryOptions = [
  "Active scheme customer",
  "New scheme join customers",
  "All customers",
  "Matured scheme customers",
];
export const conditionTypeOptions = [
  { label: "Saved amount", value: "Saved amount" },
  { label: "Payment count", value: "Payment count" },

];
export const conditionType = [
  { label: "Mandatory", value: "Mandatory" },
  { label: "Conditional", value: "Conditional" },
  { label: "Optional", value: "Optional" }
];
export const statusOptions = [
  { label: "Created", value: "Created" },
  { label: "Active", value: "Active" },
  { label: "Paused", value: "Paused" },
  { label: "Ended", value: "Ended" },
  { label: "Cancelled", value: "Cancelled" },
];
export const ticketReportHeader = [
  { label: "S.No" },
  { label: "Ticket ID" },
  { label: "Created Date" },
    { label: "Resolved Date" },

  { label: "Channel" },
  { label: "Subject" },
  { label: "Agent" },
  { label: "Status" },
];

export const modalPromptHeader = [
  {
    label: "S.No",
  },
  {
    label: "Campaign Name",
  },
  {
    label: "Start Date",
  },
  {
    label: "End Date",
  },
  {
    label: "Parameter",
  },
  {
    label: "Show To",
  },
  {
    label: "Appeared User Count",
  },
  {
    label: "Info Collected",
  },
  {
    label: "Cancelled Count",
  },
];

export const modalPromptLogsHeader = [
  {
    label: "S.No",
  },
  {
    label: "Customer Name",
  },
  {
    label: "Registered Date",
  },
  {
    label: "Mobile Number",
  },
  {
    label: "Scheme",
  },
  {
    label: "Info Filled Date",
  },
];
